import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SubscriptionService, subscriptionError } from '../../core/services/subscription.service';
import { subscriptionLabel, subscriptionMonths } from './subscription-date';

@Component({
    selector: 'app-subscription-request', imports: [CommonModule, FormsModule],
    templateUrl: './subscription-request.component.html',
    styleUrl: './subscription-request.component.css'
})
export class SubscriptionRequestComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private service = inject(SubscriptionService);
  @Input({ required: true }) member: any;
  @Input() products: any[] = [];
  @Input() subscriptions: any[] = [];
  @Input() transactionDay = 11;
  @Input() inline = false;
  @Input() kind: 'start' | 'stop' = 'start';
  @Output() saved = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() savingChanged = new EventEmitter<boolean>();
  readonly days = Array.from({ length: 31 }, (_, i) => i + 1);
  readonly label = subscriptionLabel;
  months: ReturnType<typeof subscriptionMonths> = [];
  product: any = null;
  subscription: any = null;
  month = '';
  deliveryDay: number | null = null;
  termsAgreed = false;
  saving = false;
  error = '';

  ngOnInit(): void {
    this.months = subscriptionMonths(this.kind, this.transactionDay);
    this.month = this.months[0].value;
    this.subscription = this.activeSubscriptions[0] ?? null;
  }

  get activeSubscriptions(): any[] { return this.subscriptions.filter(item => item.status === '契約中'); }
  price(product: any): number { return Math.floor(Number(product.amount || 0) * (1 + Number(product.taxRate?.rate || 0))); }

  async save(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (this.saving || Number(this.member?.status) !== 0 || !this.months.some(item => item.value === this.month)) return;
    if (this.kind === 'start' && (!this.product || !this.termsAgreed || (this.deliveryDay !== null && !this.days.includes(Number(this.deliveryDay))))) return;
    if (this.kind === 'stop' && !this.activeSubscriptions.some(item => item.id === this.subscription?.id)) return;
    this.saving = true;
    this.savingChanged.emit(true);
    this.error = '';
    try {
      if (this.kind === 'start') {
        await this.service.start(this.member.id, { productId: this.product.id, startDate: this.month, deliveryDay: this.deliveryDay === null ? null : Number(this.deliveryDay) });
      } else {
        await this.service.stop(this.member.id, { subscriptionId: this.subscription.id, endDate: this.month });
      }
      this.saved.emit();
    } catch (error) {
      this.error = subscriptionError(error);
    } finally { this.saving = false; this.savingChanged.emit(false); }
  }
  private refreshClockDates(): void {
    this.months = subscriptionMonths(this.kind, this.transactionDay);
    this.month = '';
  }

}
